/**
 * Try get a leaf/subtree of object via dot-notation (e.g.: obj.category.property-name)
 * and return it. Return false if it fails.
 *
 * @param {Object} obj Object containing configuration
 * @param {String} path String in dot-notation
 * @returns 
 */
const trygetfalse = (obj, path) => {
    if (typeof(path) !== 'string') {
        return false
    }
    for (const token of path.split('.')){
        try {
            obj = obj[token]
        } catch (error) {
            return false
        }
    }
    return obj
}

/**
 * Try get a leaf/subtree of object via dot-notation (e.g.: obj.category.property-name)
 * and return it. Return true if it fails.
 *
 * @param {Object} obj Object containing configuration
 * @param {String} path String in dot-notation
 * @returns 
 */
const trygettrue = (obj, path) => {
    if (typeof(path) !== 'string') {
        return true
    }
    for (const token of path.split('.')){
        try {
            obj = obj[token]
        } catch (error) {
            return true
        }
    }
    if(obj === undefined) {
        return true
    }
    return obj
}

/**
 * Check if ALL of the properties at the given path are not false
 *
 * @param {Object} obj Object containing configuration
 * @param {String} path String in dot-notation
 * @returns true if no properties at given path equals false
*/
const every = (obj, path) => {
    const context = trygetfalse(obj, path)
    if (typeof(context) !== 'object') {
        return context === true
    }
    return Object.values(context).every(val=>val !== false)
}

/**
 * Check if SOME of the properties at the given path are true
 *
 * @param {Object} obj Object containing configuration
 * @param {String} path String in dot-notation
 * @returns true if at least one propertie at given path equals true
*/
const some = (obj, path) => {
    const context = trygetfalse(obj, path)
    if (typeof(context) !== 'object') {
        return context === true
    }
    return Object.values(context).some(val=>val === true)
}

/**
 * Create new function that internally uses the given object for operations.
 * The given object can only be accesed by the created function, once all external
 * references to the given object are gone.
 * This behavior is desired for config-object.
*/
const createConfigCallback = (func, obj) => {
    return (param) => {
        return func(obj, param)
    }
}

// =============================================================================
//                                 PLUGIN-SETUP
// =============================================================================

const defineMixin = (options) => {
    return {
        beforeCreate() {
            // quick "how to use"
            // inside templatetag: $isRequired.get('some.object.prop-path')
            // outside templatetag: this.$isRequired.get('some.object.prop-path')
            // no import needed
            this.$isRequired = {
                get : createConfigCallback(trygetfalse, options.requiredFields),
                every : createConfigCallback(every, options.requiredFields),
                some : createConfigCallback(some, options.requiredFields),
                getNotFalse: createConfigCallback(trygettrue, options.requiredFields)
            }
        },
        unmounted() {
            delete this.$isRequired
        }
    }
}

export default {
    install: (app, options) => {
        app.mixin(defineMixin(options))
    }
}